import { useNavigate } from "react-router-dom"

import logout from "@podcastsoundboard/ps-lib/api/auth/logout"

import {
  Badge,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  IconButton,
  Typography,
} from "@podcastsoundboard/ps-lib/ui"
import AdminPanelSettingsIcon from "@podcastsoundboard/ps-lib/ui/icons/AdminPanelSettings"
import CollectionsBookmarkIcon from "@podcastsoundboard/ps-lib/ui/icons/CollectionsBookmark"
import EmailIcon from "@podcastsoundboard/ps-lib/ui/icons/Email"
import HomeIcon from "@podcastsoundboard/ps-lib/ui/icons/Home"
import LogoutIcon from "@podcastsoundboard/ps-lib/ui/icons/Logout"
import MenuIcon from "@podcastsoundboard/ps-lib/ui/icons/Menu"
import MovieFilterIcon from "@podcastsoundboard/ps-lib/ui/icons/MovieFilter"
import PersonIcon from "@podcastsoundboard/ps-lib/ui/icons/Person"

import { useAppDispatch, useAppSelector } from "../../redux"
import { setCurrentUserProfile } from "../../redux/currentUserProfile"
import { addSnackbar } from "../../redux/snackbars"

export default function AppBarItems(): JSX.Element {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleLogoutClick = async () => {
    try {
      await logout()
      dispatch(setCurrentUserProfile(null))
      dispatch(
        addSnackbar({ id: "logoutsuccess", text: "Log out successful." }),
      )
      navigate("/app")
    } catch (err) {
      console.error(err)
      dispatch(setCurrentUserProfile(null))
      navigate("/app")
    }
  }

  const currentUserProfile = useAppSelector((state) => state.currentUserProfile)

  const menuItemClasses = "flex flex-row items-center gap-6"

  return (
    <>
      {!currentUserProfile && (
        <>
          <Button color="inherit" onClick={() => navigate("/app/signin")}>
            Sign In
          </Button>
          <Button color="inherit" onClick={() => navigate("/app/signup")}>
            Sign Up
          </Button>
        </>
      )}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <IconButton color="inherit" aria-label="Open menu">
            <Badge color="secondary">
              <MenuIcon />
            </Badge>
          </IconButton>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => navigate("/app")}>
            <div className={menuItemClasses}>
              <HomeIcon />
              <Typography>Home</Typography>
            </div>
          </DropdownMenuItem>
          {currentUserProfile && (
            <DropdownMenuItem
              onSelect={() => navigate("/app/account/soundboards/new")}
            >
              <div className={menuItemClasses}>
                <MovieFilterIcon />
                <Typography>Soundboards</Typography>
              </div>
            </DropdownMenuItem>
          )}
          {currentUserProfile && (
            <DropdownMenuItem
              onSelect={() => navigate("/app/account/subscription")}
            >
              <div className={menuItemClasses}>
                <PersonIcon />
                <Typography>Account</Typography>
              </div>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem onSelect={() => navigate("/app/blog")}>
            <div className={menuItemClasses}>
              <CollectionsBookmarkIcon />
              <Typography>Guides</Typography>
            </div>
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => navigate("/app/contact")}>
            <div className={menuItemClasses}>
              <EmailIcon />
              <Typography>Contact</Typography>
            </div>
          </DropdownMenuItem>
          {currentUserProfile && (
            <DropdownMenuItem onSelect={() => void handleLogoutClick()}>
              <div className={menuItemClasses}>
                <LogoutIcon />
                <Typography>Logout</Typography>
              </div>
            </DropdownMenuItem>
          )}
          {currentUserProfile && currentUserProfile.isAdmin && (
            <DropdownMenuItem onSelect={() => navigate("/app/admin/users")}>
              <div className={menuItemClasses}>
                <AdminPanelSettingsIcon className="text-info" />
                <Typography color="info">Admin</Typography>
              </div>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
